export default "__VITE_ASSET__ByWH2MuJ__"